"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.USER_SUBSCRIPTION_STATUS = void 0;
var USER_EVENTS = /*#__PURE__*/function (USER_EVENTS) {
  USER_EVENTS["PAGE_VIEW"] = "PAGE_VIEW";
  // Page view
  USER_EVENTS["VIRTUAL_PAGE_VIEW"] = "VIRTUAL_PAGE_VIEW";
  // SPA page view
  USER_EVENTS["COMPONENT_ADD"] = "COMPONENT_ADD";
  // Component added to the page
  USER_EVENTS["COMPONENT_ERROR"] = "COMPONENT_ERROR";
  // Component error (messages, data load, etc.)
  USER_EVENTS["DATA_FETCH_ERROR"] = "DATA_FETCH_ERROR";
  // Data fetch error
  USER_EVENTS["ELEMENT_INTERACTION"] = "ELEMENT_INTERACTION";
  // Element interaction (click, swipe, etc.)
  USER_EVENTS["GDPR_ACTION"] = "GDPR_ACTION";
  // Action taken
  USER_EVENTS["NAVIGATION"] = "NAVIGATION";
  USER_EVENTS["USER_METADATA"] = "USER_METADATA"; // Adding information about the user
  return USER_EVENTS;
}(USER_EVENTS || {});
var USER_SUBSCRIPTION_STATUS = exports.USER_SUBSCRIPTION_STATUS = /*#__PURE__*/function (USER_SUBSCRIPTION_STATUS) {
  /**
   * The current user has never had a paid subscription
   */
  USER_SUBSCRIPTION_STATUS["NEW"] = "new";
  /**
   * The current user once had a paid subscription, but
   * currently does not
   */
  USER_SUBSCRIPTION_STATUS["CHURNED"] = "churned";
  /**
   * The current user has an active paid subscription
   */
  USER_SUBSCRIPTION_STATUS["ACTIVE"] = "active";
  return USER_SUBSCRIPTION_STATUS;
}({});
var _default = exports.default = USER_EVENTS;
//# sourceMappingURL=enums.js.map